import { HttpErrorResponse, HttpHandler, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';
import { BehaviorSubject, catchError, filter, finalize, switchMap, take, throwError } from 'rxjs';


export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {

  // let refreshTokenInProgress = false;
  // let refreshTokenSubject = new BehaviorSubject(null);
  
  const authToken = inject(AuthService).Token;
  const auth = inject(AuthService);

  const newReq = req.clone({    headers: req.headers.append('Authorization', `Bearer ${authToken}`),  });
  return next(newReq);
  // return next(newReq).pipe(
  //   catchError((requestError: HttpErrorResponse) => {
  //       if (requestError && requestError.status === 419) {
  //         if (refreshTokenInProgress) {
  //           return refreshTokenSubject.pipe(
  //             filter((result) => result as any),
  //             take(1),
  //             switchMap(() => next(newReq))
  //           );
  //         } else {
  //           refreshTokenInProgress = true;
  //           refreshTokenSubject.next(null);

  //           return auth.refreshAuthToken().pipe(
  //             switchMap((token) => {
  //               refreshTokenSubject.next(token);
  //               return next(newReq);
  //             }),
  //             finalize(() => (refreshTokenInProgress = false))
  //           );
  //         }
  //       } else {
  //         let errorMsg = '';         
  //         if (requestError.error instanceof ErrorEvent) {
  //           errorMsg = `Error : ${requestError.error.message}`;
  //        } else {
  //           errorMsg = `Error Code: ${requestError.status},  Message: ${requestError.message}`;
  //        }
  //        //return throwError(() => requestError.error);
          

  //        return throwError(() => new Error(requestError.error.message));
  //       }
  //     })
  // );
};
